module.exports = __webpack_public_path__ + "static/media/15-Punkte.aa07a3c6.png";